'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isMonday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isMonday.js
// module id = 548
// module chunks = 0